// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { BreakdownCard } from './shared';

export const AudienceTab: React.FC = () => (
  <div>
    <div className="grid gap-3.5 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
      <BreakdownCard title="Devices" dim="device" donut />
      <BreakdownCard title="Browsers" dim="browser" viewAll />
      <BreakdownCard title="Operating systems" dim="os" viewAll />
    </div>
    <div className="grid gap-3.5 mt-3.5 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
      <BreakdownCard title="Countries" dim="country" limit={7} viewAll />
      <BreakdownCard title="Cities" dim="city" limit={7} viewAll />
      <BreakdownCard title="New vs returning" dim="visitorType" donut />
    </div>
  </div>
);

export default AudienceTab;
